import { gql } from '@apollo/client';

export const NotifyOrganizationOwnerInvitation = gql`
  mutation NotifyOrganizationOwnerInvitation(
    $accountCode: String!
    $inviteeEmail: String!
    $message: String
  ) {
    notifyOrganizationOwnerInvitation(
      accountCode: $accountCode
      inviteeEmail: $inviteeEmail
      message: $message
    )
  }
`;
